import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ConfirmModal } from '../ConfirmModal';


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteRouteSubscriptionModal',
  props: {
    to: {},
    error: {}
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const handleConfirm = () => {
  emit('confirm');
};

const handleCancel = () => {
  emit('cancel');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ConfirmModal), {
    to: _ctx.to,
    error: _ctx.error,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  }, {
    default: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", null, [
        _createElementVNode("h2", { class: "h5" }, " Are you sure you want to delete your subscription? ")
      ], -1),
      _createElementVNode("p", null, "You will no longer receive SMS updates for this route once you delete your subscription.", -1)
    ])),
    _: 1,
    __: [0]
  }, 8, ["to", "error"]))
}
}

})